import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import VideosApi from './VideosApi';

let settings;

export default settings = {
    key: 'videos',
    zone: 'videos',
    path: '/videos',
    title: "Videos",
    endpoint: VideosApi.endpoint,
    modelName: 'Videos',
    idKey: 'id',
    primaryKey: 'title',
    actions: ['trash', 'clone'],
    indexCaps: ["viewVideos"],
    viewCaps: ["viewVideos"],
    createCaps: ["createVideos"],
    updateCaps: ["updateVideos"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: VideosApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['activity', 'topic'], order: ["order asc", 'created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['title'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Title",
                key: "title",
                type: "text",
            },
            {
                label: "Sport / Activity",
                key: "activityId",
                type: "relationship",
                model: "SportsActivities",
            },
            {
                label: "Video Topic",
                key: "topicId",
                type: "relationship",
                model: "VideoTopics",
            },
            {
                label: "Status",
                key: "status",
                type: "choice",
                options: [
                    { value: "preview", label: "Preview" },
                    { value: "live", label: "Live" },
                    { value: "archive", label: "Archive" },
                ]
            },

        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Title",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Status",
                key: "status",
                type: 'text',
                format: "titleCase",
            },

            {
                label: "Sport / Activity",
                key: "activity",
                format: "modelLink",
            },

            {
                label: "Video Topic",
                key: "topic",
                format: "modelLink",
            },

            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: VideosApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: VideosApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['activity', 'topic'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit",

            },
        ]

    },
};